import GoBackHeader from 'components/organisms/GoBackHeader'
import { useAppDispatch, useAppSelector } from 'hooks/store'
import { FC, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { Redirect, useHistory } from 'react-router-dom'
import {
  setCurrentActiveGroup,
  setCurrentActiveQuestionId
} from 'reducers/activesection/activesectionSlice'
import QuestionnaireSectionSummaryCard from '../Components/QuestionnaireSectionSummaryCard'
import {
  QuestionnaireSectionSummaryCardWrapper,
  QuestionnaireSectionSummaryContainer,
  QuestionnaireSectionSummaryReadOnlyNotification
} from './styles'
import { MatterClientPortalQuestionnaireSectionStatus } from 'share/domain/case'

const QuestionnaireSectionGroupSummary: FC = () => {
  const dispatch = useAppDispatch()
  const activeSection = useAppSelector((state) => state.activeSection)
  const activeSectionStatus = activeSection.section?.sectionStatus

  const history = useHistory()
  const [selectedGroup, setSelectedGroup] = useState<Record<string, unknown>>(
    {}
  )
  const [questions, setQuestions] = useState<unknown[]>([])
  const activeQuestionId = useAppSelector(
    (state) => state.activeSection.section?.currentActiveQuestionId
  )
  const [summaryHeader, setSummaryHeader] = useState<string>('')

  function getSectionId() {
    if (activeSection) {
      if (activeSection.section) {
        if (activeSection.section.id) {
          return activeSection.section.id
        }
      }
    }
    return 0
  }

  const handleClick = (questionId: number) => {
    dispatch(setCurrentActiveQuestionId(questionId))
  }

  function goBackHeaderOnClick() {
    dispatch(setCurrentActiveGroup(null))
    history.push('/dashboard/questionnaires/sectionsummary/' + getSectionId())
  }

  useEffect(() => {
    const selectedGroup =
      activeSection.section?.sectionUiTransformedModel.Groups.find(
        (group: { QuestionGroupId: number | null | undefined }) => {
          return (
            group.QuestionGroupId === activeSection.section?.currentActiveGroup
          )
        }
      )

    setSelectedGroup(selectedGroup)

    if (selectedGroup && selectedGroup.Questions?.length) {
      setQuestions(selectedGroup.Questions)
      setSummaryHeader(selectedGroup.Name)
    }
  }, [activeSection])

  if (activeQuestionId != null) {
    return (
      <Redirect
        to={{
          pathname: `/dashboard/questionnaires/question`,
          state: { navigationQuestionId: activeQuestionId }
        }}
      />
    )
  }

  return (
    <>
      <GoBackHeader
        text={activeSection.section?.sectionName}
        onClick={goBackHeaderOnClick}
      />
      <QuestionnaireSectionSummaryContainer>
        {activeSectionStatus ===
          MatterClientPortalQuestionnaireSectionStatus.Submitted ||
        activeSectionStatus ===
          MatterClientPortalQuestionnaireSectionStatus.Imported ? (
          <QuestionnaireSectionSummaryReadOnlyNotification>
            <div style={{ display: 'flex' }}>
              <span className='mdi mdi-information blue-info-icon mr-1'></span>
              <span data-testid='questionnaire-summary-read-only-notification'>
                This section was submitted. You may view it in read-only mode.
              </span>
            </div>
          </QuestionnaireSectionSummaryReadOnlyNotification>
        ) : (
          <></>
        )}
        {summaryHeader && <h2 className='summary-header'>{summaryHeader}</h2>}
        <div className='summary-description'>
          {selectedGroup?.Description &&
          typeof selectedGroup.Description === 'string' ? (
            selectedGroup.Description.split('\\n').join('\n')
          ) : (
            <></>
          )}
        </div>
        <QuestionnaireSectionSummaryCardWrapper>
          {questions?.map(
            // eslint-disable-next-line
            (value: any) => {
              return (
                <QuestionnaireSectionSummaryCard
                  key={value.Name}
                  {...value}
                  handleClick={handleClick}
                ></QuestionnaireSectionSummaryCard>
              )
            }
          )}
        </QuestionnaireSectionSummaryCardWrapper>
        <div className='btn-container'>
          <Button
            variant='outline-secondary'
            onClick={goBackHeaderOnClick}
            data-testid='questionnaire-back-btn'
          >
            Back
          </Button>
        </div>
        {activeSectionStatus !==
          MatterClientPortalQuestionnaireSectionStatus.Submitted &&
        activeSectionStatus !==
          MatterClientPortalQuestionnaireSectionStatus.Imported ? (
          <div
            className='save-finish-later-link'
            data-testid='questionnaire-save-and-finish-btn'
          >
            <a href='#' onClick={goBackHeaderOnClick}>
              Save and Finish Later
            </a>
          </div>
        ) : (
          <></>
        )}
        <div className='questionnaire-summary-important'>
          <span className='mdi mdi-information-outline' />
          <span> Important</span>
        </div>
        <div className='questionnaire-summary-important-text'>
          You can still add, edit, and delete any records in this section before
          sending the questionnaire to your attorney.
        </div>
      </QuestionnaireSectionSummaryContainer>
    </>
  )
}

export default QuestionnaireSectionGroupSummary
